import { redirect } from 'react-router';
import type { RouteObject } from 'react-router';
import { PhotoOrganizerLayout } from './pages/PhotoOrganizerLayout';
import { UploadMain } from './main/UploadMain';
import { ClassifySiteMain } from './main/ClassifySiteMain';
import { TagBulkEditMain } from './main/TagBulkEditMain';
import { SiteListMain } from './main/SiteListMain';
import { SiteDetailMain } from './main/SiteDetailMain';
import { PhotoDetailMain } from './main/PhotoDetailMain';
import { SearchMain } from './main/SearchMain';
import { ShareSendMain } from './main/ShareSendMain';
import { ShareHistoryMain } from './main/ShareHistoryMain';
import { PhotoAlbumShareViewPage } from './pages/PhotoAlbumShareViewPage';
import { MobileHandoffUploadPage } from './pages/MobileHandoffUploadPage';
import { AppInstallGuidePage } from './pages/AppInstallGuidePage';

export const routes: RouteObject[] = [
  {
    path: 'agents/photo-organizer',
    Component: PhotoOrganizerLayout,
    children: [
      { index: true, loader: () => redirect('upload') },
      { path: 'upload',        Component: UploadMain },
      { path: 'classify-site', Component: ClassifySiteMain },
      { path: 'tag-bulk-edit', Component: TagBulkEditMain },
      { path: 'site-list',     Component: SiteListMain },
      { path: 'site/:siteId',  Component: SiteDetailMain },
      { path: 'photo-detail',  Component: PhotoDetailMain },
      { path: 'search',        Component: SearchMain },
      // 공유하기는 share-send 한 화면으로 통합됐다(우측 현장 패널 + 사진 선택 + 수신자). 메뉴·홈 카드·북마크가 가리키는
      // 기존 /share 경로는 그대로 두고 여기서 넘긴다.
      { path: 'share',         loader: () => redirect('/agents/photo-organizer/share-send') },
      { path: 'share-send',    Component: ShareSendMain },
      { path: 'share-history', Component: ShareHistoryMain },
    ],
  },
];

// 외부공유 수신자 뷰어 — 공개 라우트 (F-04 §7, 인증 불요)
export const shareRoutes: RouteObject[] = [
  { path: 'share/PHOTO_ALBUM_SHARE',         Component: PhotoAlbumShareViewPage },
  { path: 'share/PHOTO_ALBUM_SHARE/PREVIEW', Component: PhotoAlbumShareViewPage },
  // QR 핸드오프 모바일 업로드 — 공개 라우트(인증 불요). QR URL: ${origin}/m/photo-upload?t=<token>
  { path: 'm/photo-upload',                  Component: MobileHandoffUploadPage },
  // QR 완전 핸드오프 고정 딥링크 — 앱이 설치돼 있으면 App Links가 가로채므로 여기 닿는 건 미설치 상태.
  // 스토어로 안내한다(전환 설계 v1.0 §7-3). 아래 '/u/:token' 보다 **앞에** 둔다.
  { path: 'u/photo-upload',                  Component: AppInstallGuidePage },
  // sv-photo가 발급하는 deepLinkUrl 표준 경로(Photo QR 핸드오프 설계 v1.0 §6 — indipia.ai/u/{token}).
  // idpMobile 앱 미설치 상태(App Links 미검증)에서 웹으로 착지하는 폴백 — 같은 페이지가 :token 파라미터도 읽는다.
  // 실 기기에서 앱이 설치돼 있으면 App Links(§14-1)가 이 경로를 가로채 브라우저에 닿지 않는다.
  { path: 'u/:token',                        Component: MobileHandoffUploadPage },
];
